/**
 * @param {object} statistics - statistics object
 * @param {object} filters - filters object
 */
export const getCountPhotos = (statistics, filters) => {
  if (statistics && statistics.overall && statistics.overall.origins) {
    const overall = Object.entries(statistics.overall.origins).reduce(
      (currentState, originEntries) => {
        const origin = originEntries[0];
        const dataSources = originEntries[1].dataSources;
        const partialPhotos =
          dataSources &&
          Object.entries(dataSources).reduce(
            (currentState, dataSourceEntries) => {
              const dataSource = dataSourceEntries[0];
              const categories =
                dataSourceEntries[1][
                  filters.recognition || 'vinne_annotation'
                ] &&
                dataSourceEntries[1][filters.recognition || 'vinne_annotation']
                  .categories;
              const partialPhotos =
                categories &&
                Object.entries(categories).reduce(
                  (currentState, categoryEntries) => {
                    const category = categoryEntries[0];
                    const tags = categoryEntries[1].tags;
                    const partialPhotos =
                      tags &&
                      Object.entries(tags).reduce(
                        (currentState, tagEntries) => {
                          const tag = tagEntries[0];
                          const photos = tagEntries[1].photos;
                          const annotated = tagEntries[1].annotated;
                          const verified = tagEntries[1].verified;
                          const reserved = tagEntries[1].reserved;
                          const rejected = tagEntries[1].rejected;

                          const isPassCriteria = (
                            origin,
                            creationDate,
                            dataSource,
                            category,
                            tag
                          ) =>
                            (!filters.origin ||
                              (filters.origin && filters.origin === origin)) &&
                            (!filters.startDate ||
                              (filters.startDate &&
                                filters.startDate <= creationDate)) &&
                            (!filters.endDate ||
                              (filters.endDate &&
                                filters.endDate >= creationDate)) &&
                            (!filters.dataSource ||
                              (filters.dataSource &&
                                filters.dataSource === dataSource)) &&
                            ((!filters.dataSource && !filters.tags) ||
                              (filters.dataSource && !filters.tags) ||
                              (filters.dataSource &&
                                Object.values(filters.tags).filter((tag) => tag)
                                  .length === 0) ||
                              (filters.dataSource &&
                                filters.tags &&
                                filters.tags[category] &&
                                filters.tags[category]
                                  .split(',')
                                  .includes(tag)));

                          const partialUniquePhotos =
                            (photos &&
                              Object.values(photos).reduce(
                                (currentState, photos) => {
                                  return currentState
                                    .concat(photos)
                                    .filter(
                                      (photo, index, photos) =>
                                        photos.indexOf(photo) === index
                                    );
                                },
                                []
                              )) ||
                            [];

                          const partialUniqueAnnotatedPhotos =
                            (annotated &&
                              Object.values(annotated).reduce(
                                (currentState, photos) => {
                                  return currentState
                                    .concat(photos)
                                    .filter(
                                      (photo, index, photos) =>
                                        photos.indexOf(photo) === index
                                    );
                                },
                                []
                              )) ||
                            [];

                          const partialUniqueCriteriaPhotos =
                            (photos &&
                              Object.entries(photos).reduce(
                                (currentState, creationDateEntries) => {
                                  const creationDate = creationDateEntries[0];
                                  const photos = creationDateEntries[1];
                                  if (
                                    isPassCriteria(
                                      origin,
                                      creationDate,
                                      dataSource,
                                      category,
                                      tag
                                    )
                                  )
                                    return currentState
                                      .concat(photos)
                                      .filter(
                                        (photo, index, photos) =>
                                          photos.indexOf(photo) === index
                                      );

                                  return currentState;
                                },
                                []
                              )) ||
                            [];

                          const partialUniqueCriteriaAnnotatedPhotos =
                            (annotated &&
                              Object.entries(annotated).reduce(
                                (currentState, creationDateEntries) => {
                                  const creationDate = creationDateEntries[0];
                                  const photos = creationDateEntries[1];
                                  if (
                                    isPassCriteria(
                                      origin,
                                      creationDate,
                                      dataSource,
                                      category,
                                      tag
                                    )
                                  )
                                    return currentState
                                      .concat(photos)
                                      .filter(
                                        (photo, index, photos) =>
                                          photos.indexOf(photo) === index
                                      );
                                  return currentState;
                                },
                                []
                              )) ||
                            [];

                          const partialUniqueCriteriaVerifiedPhotos =
                            (verified &&
                              Object.entries(verified).reduce(
                                (currentState, creationDateEntries) => {
                                  const creationDate = creationDateEntries[0];
                                  const photos = creationDateEntries[1];
                                  if (
                                    isPassCriteria(
                                      origin,
                                      creationDate,
                                      dataSource,
                                      category,
                                      tag
                                    )
                                  )
                                    return currentState
                                      .concat(photos)
                                      .filter(
                                        (photo, index, photos) =>
                                          photos.indexOf(photo) === index
                                      );
                                  return currentState;
                                },
                                []
                              )) ||
                            [];

                          const partialUniqueCriteriaReservedPhotos =
                            (reserved &&
                              Object.entries(reserved).reduce(
                                (currentState, creationDateEntries) => {
                                  const creationDate = creationDateEntries[0];
                                  const photos = creationDateEntries[1];
                                  if (
                                    isPassCriteria(
                                      origin,
                                      creationDate,
                                      dataSource,
                                      category,
                                      tag
                                    )
                                  )
                                    return currentState
                                      .concat(photos)
                                      .filter(
                                        (photo, index, photos) =>
                                          photos.indexOf(photo) === index
                                      );
                                  return currentState;
                                },
                                []
                              )) ||
                            [];

                          const partialUniqueCriteriaRejectedPhotos =
                            (rejected &&
                              Object.entries(rejected).reduce(
                                (currentState, creationDateEntries) => {
                                  const creationDate = creationDateEntries[0];
                                  const photos = creationDateEntries[1];
                                  if (
                                    isPassCriteria(
                                      origin,
                                      creationDate,
                                      dataSource,
                                      category,
                                      tag
                                    )
                                  )
                                    return currentState
                                      .concat(photos)
                                      .filter(
                                        (photo, index, photos) =>
                                          photos.indexOf(photo) === index
                                      );
                                  return currentState;
                                },
                                []
                              )) ||
                            [];

                          currentState.total = currentState.total
                            .concat(partialUniquePhotos)
                            .filter(
                              (photo, index, photos) =>
                                photos.indexOf(photo) === index
                            );

                          currentState.tagged = currentState.tagged
                            .concat(partialUniqueAnnotatedPhotos)
                            .filter(
                              (photo, index, photos) =>
                                photos.indexOf(photo) === index
                            );

                          currentState.notTagged = currentState.notTagged
                            .concat(partialUniquePhotos)
                            .filter(
                              (photo, index, photos) =>
                                photos.indexOf(photo) === index &&
                                !(
                                  partialUniqueAnnotatedPhotos &&
                                  partialUniqueAnnotatedPhotos.includes(photo)
                                )
                            );

                          currentState.criteriaPhotos = currentState.criteriaPhotos
                            .concat(partialUniqueCriteriaPhotos)
                            .filter(
                              (photo, index, photos) =>
                                photos.indexOf(photo) === index
                            );

                          currentState.criteriaAnnotated = currentState.criteriaAnnotated
                            .concat(partialUniqueCriteriaAnnotatedPhotos)
                            .filter(
                              (photo, index, photos) =>
                                photos.indexOf(photo) === index
                            );

                          currentState.criteriaVerified = currentState.criteriaVerified
                            .concat(partialUniqueCriteriaVerifiedPhotos)
                            .filter(
                              (photo, index, photos) =>
                                photos.indexOf(photo) === index
                            );

                          currentState.criteriaReserved = currentState.criteriaReserved
                            .concat(partialUniqueCriteriaReservedPhotos)
                            .filter(
                              (photo, index, photos) =>
                                photos.indexOf(photo) === index
                            );

                          currentState.criteriaRejected = currentState.criteriaRejected
                            .concat(partialUniqueCriteriaRejectedPhotos)
                            .filter(
                              (photo, index, photos) =>
                                photos.indexOf(photo) === index
                            );

                          return currentState;
                        },
                        {
                          total: [],
                          tagged: [],
                          notTagged: [],
                          criteriaPhotos: [],
                          criteriaAnnotated: [],
                          criteriaVerified: [],
                          criteriaReserved: [],
                          criteriaRejected: [],
                        }
                      );
                    if (partialPhotos) {
                      currentState.total = currentState.total
                        .concat(partialPhotos.total)
                        .filter(
                          (photo, index, photos) =>
                            photos.indexOf(photo) === index
                        );
                      currentState.tagged = currentState.tagged
                        .concat(partialPhotos.tagged)
                        .filter(
                          (photo, index, photos) =>
                            photos.indexOf(photo) === index
                        );
                      currentState.notTagged = currentState.notTagged
                        .concat(partialPhotos.total)
                        .filter(
                          (photo, index, photos) =>
                            photos.indexOf(photo) === index &&
                            !(
                              currentState.tagged &&
                              currentState.tagged.includes(photo)
                            )
                        );

                      currentState.criteriaPhotos = currentState.criteriaPhotos
                        .concat(partialPhotos.criteriaPhotos)
                        .filter(
                          (photo, index, photos) =>
                            photos.indexOf(photo) === index
                        );

                      currentState.criteriaAnnotated = currentState.criteriaAnnotated
                        .concat(partialPhotos.criteriaAnnotated)
                        .filter(
                          (photo, index, photos) =>
                            photos.indexOf(photo) === index
                        );

                      currentState.criteriaVerified = currentState.criteriaVerified
                        .concat(partialPhotos.criteriaVerified)
                        .filter(
                          (photo, index, photos) =>
                            photos.indexOf(photo) === index
                        );

                      currentState.criteriaReserved = currentState.criteriaReserved
                        .concat(partialPhotos.criteriaReserved)
                        .filter(
                          (photo, index, photos) =>
                            photos.indexOf(photo) === index
                        );

                      currentState.criteriaRejected = currentState.criteriaRejected
                        .concat(partialPhotos.criteriaRejected)
                        .filter(
                          (photo, index, photos) =>
                            photos.indexOf(photo) === index
                        );
                    }
                    return currentState;
                  },
                  {
                    total: [],
                    tagged: [],
                    notTagged: [],
                    criteriaPhotos: [],
                    criteriaAnnotated: [],
                    criteriaVerified: [],
                    criteriaReserved: [],
                    criteriaRejected: [],
                  }
                );
              if (partialPhotos) {
                currentState.total = currentState.total
                  .concat(partialPhotos.total)
                  .filter(
                    (photo, index, photos) => photos.indexOf(photo) === index
                  );
                currentState.tagged = currentState.tagged
                  .concat(partialPhotos.tagged)
                  .filter(
                    (photo, index, photos) => photos.indexOf(photo) === index
                  );
                currentState.notTagged = currentState.notTagged
                  .concat(partialPhotos.total)
                  .filter(
                    (photo, index, photos) =>
                      photos.indexOf(photo) === index &&
                      !(
                        currentState.tagged &&
                        currentState.tagged.includes(photo)
                      )
                  );

                currentState.criteriaPhotos = currentState.criteriaPhotos
                  .concat(partialPhotos.criteriaPhotos)
                  .filter(
                    (photo, index, photos) => photos.indexOf(photo) === index
                  );

                currentState.criteriaAnnotated = currentState.criteriaAnnotated
                  .concat(partialPhotos.criteriaAnnotated)
                  .filter(
                    (photo, index, photos) => photos.indexOf(photo) === index
                  );

                currentState.criteriaVerified = currentState.criteriaVerified
                  .concat(partialPhotos.criteriaVerified)
                  .filter(
                    (photo, index, photos) => photos.indexOf(photo) === index
                  );

                currentState.criteriaReserved = currentState.criteriaReserved
                  .concat(partialPhotos.criteriaReserved)
                  .filter(
                    (photo, index, photos) => photos.indexOf(photo) === index
                  );

                currentState.criteriaRejected = currentState.criteriaRejected
                  .concat(partialPhotos.criteriaRejected)
                  .filter(
                    (photo, index, photos) => photos.indexOf(photo) === index
                  );
              }
              return currentState;
            },
            {
              total: [],
              tagged: [],
              notTagged: [],
              criteriaPhotos: [],
              criteriaAnnotated: [],
              criteriaVerified: [],
              criteriaReserved: [],
              criteriaRejected: [],
            }
          );

        if (partialPhotos) {
          currentState.total = currentState.total
            .concat(partialPhotos.total)
            .filter((photo, index, photos) => photos.indexOf(photo) === index);

          currentState.tagged = currentState.tagged
            .concat(partialPhotos.tagged)
            .filter((photo, index, photos) => photos.indexOf(photo) === index);

          currentState.notTagged = currentState.notTagged
            .concat(partialPhotos.total)
            .filter(
              (photo, index, photos) =>
                photos.indexOf(photo) === index &&
                !(currentState.tagged && currentState.tagged.includes(photo))
            );

          currentState.criteriaPhotos = currentState.criteriaPhotos
            .concat(partialPhotos.criteriaPhotos)
            .filter((photo, index, photos) => photos.indexOf(photo) === index);

          currentState.criteriaAnnotated = currentState.criteriaAnnotated
            .concat(partialPhotos.criteriaAnnotated)
            .filter((photo, index, photos) => photos.indexOf(photo) === index);

          currentState.criteriaVerified = currentState.criteriaVerified
            .concat(partialPhotos.criteriaVerified)
            .filter((photo, index, photos) => photos.indexOf(photo) === index);

          currentState.criteriaReserved = currentState.criteriaReserved
            .concat(partialPhotos.criteriaReserved)
            .filter((photo, index, photos) => photos.indexOf(photo) === index);

          currentState.criteriaRejected = currentState.criteriaRejected
            .concat(partialPhotos.criteriaRejected)
            .filter((photo, index, photos) => photos.indexOf(photo) === index);
        }
        return currentState;
      },
      {
        total: [],
        tagged: [],
        notTagged: [],
        criteriaPhotos: [],
        criteriaAnnotated: [],
        criteriaVerified: [],
        criteriaReserved: [],
        criteriaRejected: [],
      }
    );

    let criteria = overall.criteriaPhotos;

    if (filters.annotated === false)
      criteria = criteria.filter(
        (photo) => !overall.criteriaAnnotated.includes(photo)
      );
    else if (filters.annotated === true)
      criteria = criteria.filter((photo) =>
        overall.criteriaAnnotated.includes(photo)
      );

    if (filters.verified === false)
      criteria = criteria.filter(
        (photo) => !overall.criteriaVerified.includes(photo)
      );
    else if (filters.verified === true)
      criteria = criteria.filter((photo) =>
        overall.criteriaVerified.includes(photo)
      );

    if (filters.reserved === false)
      criteria = criteria.filter(
        (photo) => !overall.criteriaReserved.includes(photo)
      );
    else if (filters.reserved === true)
      criteria = criteria.filter((photo) =>
        overall.criteriaReserved.includes(photo)
      );

    if (filters.rejected === false)
      criteria = criteria.filter(
        (photo) => !overall.criteriaRejected.includes(photo)
      );
    else if (filters.rejected === true)
      criteria = criteria.filter((photo) =>
        overall.criteriaRejected.includes(photo)
      );

    return {
      total: overall.total,
      tagged: overall.tagged,
      notTagged: overall.notTagged,
      criteria,
    };
  } else return { total: [], tagged: [], notTagged: [], criteria: [] };
};
